import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  container: {
    flex: 1,
    minHeight: 16,
  },
});
